import { useState } from "react";
import styles from "./PasswordInput.module.scss";
import classNames from "classnames/bind";
import { VisibilityIcon, VisibilityOffIcon } from "~/assets/icons";
const cx = classNames.bind(styles);

const PasswordInput = (props: {
  label?: string;
  placeholder?: string;
  value?: string;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  className?: string;
}) => {
  const { label, placeholder, value, name, onChange, errorMessage, className } =
    props;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={cx("password-input-container", className)}>
      {label && (
        <label htmlFor={name} className={cx("input-label")}>
          {label}
        </label>
      )}
      <div className={cx("input-wrapper")}>
        <input
          id={name}
          name={name}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          value={value ?? ""}
          onChange={onChange}
          className={cx("input-field", { error: !!errorMessage })}
        />
        <button
          type="button"
          className={cx("show-password-button")}
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <VisibilityIcon className={cx("icon")} />
          ) : (
            <VisibilityOffIcon className={cx("icon")} />
          )}
        </button>
      </div>
      {errorMessage && <p className={cx("error-message")}>{errorMessage}</p>}
    </div>
  );
};

export default PasswordInput;
